// extracted by mini-css-extract-plugin
export var button = "_dt-7";
export var buttonRow = "_dt-6";
export var fadeIn = "_dt-1";
export var gradient = "_dt-0";
export var panel = "_dt-2";
export var panelIn = "_dt-3";
export var subtitle = "_dt-5";
export var title = "_dt-4";